export default __webpack_public_path__ + "media/images/modifier-7824757bd1f7e531ce113782debc1890.png";